import React from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Add
} from "@mui/icons-material";

import { makeStyles } from "@utilities/theme_utilities";

import { Feature } from "@models";
import { CharacterFeatureSource, CharacterSheetInterface, BasicCreatureInstance, SummonInstance } from "@dndModels";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

interface Props {
  label: string;
  plural?: string;
  parent_type: string;
  parent_id: string;
  features: Feature[];
  // onChange: (features: Feature[]) => void; 
  onExpand: (feature: Feature) => void;
  onAdd: () => void;
  disabled?: boolean;
  cfs?: CharacterSheetInterface | BasicCreatureInstance | SummonInstance | CharacterFeatureSource;
}

export default function FeatureListInput({
  label,
  plural = "",
  // parent_type,
  // parent_id,
  features,
  onExpand,
  onAdd,
  disabled = false,
  cfs
}: Props) {
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        '&.tableHeader': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.secondary.dark,
        },
        '&.alternate': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.dark,
        },
      },
    });
  });
  
  const descWidth = Math.floor(window.innerWidth * 0.8);
  const { classes, cx } = useStyles();
  return (
    <Grid container spacing={0} direction="column">
      <Grid>
        <span className="header">
          { plural === "" ? `${label}s` : plural }
        </span>
        { !disabled && 
          <Tooltip title={`Create New ${label}`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onAdd();
              }}>
              <Add/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      { features.map((feature, key) => {
        return (
          <Grid key={feature.true_id}
            container spacing={0} direction="row"
            className={cx(classes.root, (key % 2 === 1 ? (disabled ? "alternate" : "alternate clickable") : (disabled ? "" : "clickable") ))}
            onClick={() => {
              if (!disabled) {
                onExpand(feature);
              }
            }}>
            <Grid size={2}>
              { feature.name === "" ? `Nameless ${label}` : feature.name }
            </Grid>
            <Grid size={10}>
              <DisplayStringWithReplacements
                display_string={feature.description}
                cfs={cfs}
                descWidth={descWidth}
              />
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}
